var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUserProfileMenuInsuranceBenefit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v28H0V0Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)",
    stroke: "currentColor",
    strokeWidth: 1.699,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.046 7.607c-.014-.711-.027-1.384-.027-2.034a.923.923 0 0 0-.922-.923c-3.946 0-6.95-1.134-9.454-3.568a.922.922 0 0 0-1.287 0C10.852 3.516 7.85 4.65 3.903 4.65a.923.923 0 0 0-.922.923c0 .65-.013 1.323-.027 2.035-.126 6.623-.3 15.693 10.743 19.52a.92.92 0 0 0 .605 0c11.043-3.827 10.87-12.898 10.744-19.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.637 12.089v-3.46h-3.274v3.46h-3.46v3.274h3.46v3.46h3.274v-3.46h3.46v-3.274h-3.46Z",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserProfileMenuInsuranceBenefit);
export default __webpack_public_path__ + "static/media/icon_user_profile_menu_insurance_benefit.cb7c2dc6.svg";
export { ForwardRef as ReactComponent };